export const formatToBoolValue = (v: string) => {
    const yesValues = ['yes', 'y', 'true']
    return yesValues.includes(v.toLowerCase()) ? 'true' : 'false'
}

export const formatFromBoolValue = (v: string) => {
    return v === null ? v : v === 'true' ? 'Yes' : 'No'
}
